import {
  AuthService,
  GraphQLService,
  WebSocketService,
} from '@pique/core/modules/cloud';
import {
  type Framework,
  type FrameworkProvider,
  GlobalState,
  WorkspaceFlavourProvider,
} from '@toeverything/infra';

import { CloudWorkspaceFlavourProviderService } from './impls/cloud';
import { IndexedDBBlobStorage } from './impls/engine/blob-indexeddb';
import { SqliteBlobStorage } from './impls/engine/blob-sqlite';
import { IndexedDBDocStorage } from './impls/engine/doc-indexeddb';
import { SqliteDocStorage } from './impls/engine/doc-sqlite';
import { LocalWorkspaceFlavourProvider } from './impls/local';
import { WorkspaceEngineStorageProvider } from './providers/engine';

export { CloudBlobStorage } from './impls/engine/blob-cloud';

export function configureBrowserWorkspaceFlavours(framework: Framework) {
  framework
    .impl(WorkspaceFlavourProvider('LOCAL'), LocalWorkspaceFlavourProvider, [
      WorkspaceEngineStorageProvider,
    ])
    .service(CloudWorkspaceFlavourProviderService, [
      GlobalState,
      AuthService,
      WorkspaceEngineStorageProvider,
      GraphQLService,
      WebSocketService,
    ])
    .impl(WorkspaceFlavourProvider('CLOUD'), (p: FrameworkProvider) =>
      p.get(CloudWorkspaceFlavourProviderService)
    );
}

export function configureIndexedDBWorkspaceEngineStorageProvider(
  framework: Framework
) {
  framework.impl(WorkspaceEngineStorageProvider, {
    getDocStorage(workspaceId: string) {
      return new IndexedDBDocStorage(workspaceId);
    },
    getBlobStorage(workspaceId: string) {
      return new IndexedDBBlobStorage(workspaceId);
    },
  });
}

export function configureSqliteWorkspaceEngineStorageProvider(
  framework: Framework
) {
  framework.impl(WorkspaceEngineStorageProvider, {
    getDocStorage(workspaceId: string) {
      return new SqliteDocStorage(workspaceId);
    },
    getBlobStorage(workspaceId: string) {
      return new SqliteBlobStorage(workspaceId);
    },
  });
}

export function configureWorkspaceEngineStorageProvider(framework: Framework) {
  if (environment.isTauri) {
    configureSqliteWorkspaceEngineStorageProvider(framework);
  } else {
    configureIndexedDBWorkspaceEngineStorageProvider(framework);
  }
}
